import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const selectTerritories = createSelector(
  (state: RootState) => state.territoryData,
  data => ({ ...data }),
);

export const selectTerritoriesData = createSelector(
  selectTerritories,
  data => data.territories,
);

export const selectTerritoryByCountryCode = createSelector(
  selectTerritories,
  data => data.territoryByCountryCode,
);
